import React, { FC } from "react";

interface ButtonProps {
  title: any;
  onClick: any;
  isLoading?: boolean;
  className?: string;
  icon?: any;
  disabled?: boolean;
}

const ButtonOutline: FC<ButtonProps> = ({ disabled = false, title, onClick, isLoading, className, icon }) => {
  return (
    <button disabled={disabled} className={`border-[1.5px] flex items-center justify-center gap-2 border-black h-12 hover:bg-black hover:text-white rounded-md md:rounded-3xl  w-full  md:w-52  font-bold ${isLoading && "opacity-50 pointer-events-none"} ${className}`} onClick={onClick}>
      {isLoading && <div className="w-4 h-4 border-[2px] border-t-[#dea15c]  rounded-full animate-spin"></div>}
      {icon}
      {title}
    </button>
  );
};

export default ButtonOutline;
